import React,{StrictMode} from 'react';
import { Home } from './views/home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import GlobalStyles from "./global";
import {
  ErrorBoundary,
  NotFound,
  Spinner,
  SpinnerSize,
  AuthRoute, 
  Content
} from './components';
import { Dashboard } from './views/dashboard';
import Auth from './views/auth';
import { AboutUs } from './views/aboutus';
import { Pricing } from './views/pricing';
import { Signup } from './views/signup';
import { ToastContainer, toast } from 'react-toastify';
import { Menu } from './components/containers/menubar';
import  { MainContainer }  from './components/containers/maincontainer';
import  { Header }  from './components/containers/topheader';
import  { ContentContainer }  from './components/containers/contentcontainer';
import { ForgetPassword } from './views/forgetpassword';
import { NewPassword } from './views/newpassword';
import { MyDevices } from './views/mydevices';
import { AppProvider } from './AppContext';
import { DownloadScan } from './views/DownloadScan';
import { AllScan } from './views/allscans';
import { CustomerCare } from './views/customercare';
const AuthenticatedApp = () => {
  return (
    <AppProvider>
    <StrictMode>
    <ErrorBoundary>
      <ErrorBoundary>
        <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}> 
        <MainContainer>
        <Menu/>
        <ContentContainer>
        <Header/>
          <Routes>
            <Route element={<AuthRoute />}>
              <Route path='dashboard' element={<Dashboard />} />   
              <Route path='mydevices' element={<MyDevices />} />   
              <Route path='allscan' element={<AllScan />} />   
              <Route path='scan' element={<DownloadScan />} />   
              <Route path='customercare' element={<CustomerCare />} />   
              
              <Route path='*' element={<NotFound />} />
            </Route>
          </Routes>
          </ContentContainer>
          </MainContainer>
        </Suspense>
      </ErrorBoundary>
    </ErrorBoundary>
    <ToastContainer />
    </StrictMode>
    </AppProvider>
  );
};

const App = () => {
  return (
    <StrictMode>
    <ErrorBoundary>
      <Content>
        
        <Router>
          <ErrorBoundary>
            <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <GlobalStyles/>
              <Routes>
              
                <Route index path='/' element={<Home />} />
                <Route index path='/home' element={<Home />} />
                <Route index path='/aboutus' element={<AboutUs />} />
                <Route index path='/pricing' element={<Pricing />} />
                <Route index path='/signup' element={<Signup />} />  
                <Route index path='/forgotpassword' element={<ForgetPassword />} />  
                <Route index path='/resetpassword' element={<NewPassword />} />                  
                <Route path='*' element={<AuthenticatedApp />} />
                <Route path='auth/*' element={<Auth />} />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </Router>
      </Content>
    </ErrorBoundary>
    <ToastContainer />
    </StrictMode>
  );
};

export default App;
